import { __decorate, __metadata } from "tslib";
import { lazyAppContextConsumer } from '@1inch-community/core/lazy';
import { appendClass } from '@1inch-community/core/lit-utils';
import { getChainById } from '@1inch-community/sdk/chain';
import '@1inch-community/ui-components/marquee';
import { Task } from '@lit/task';
import { html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import '../../balance-view';
import '../../token-icon';
import { favoriteToken, selectToken } from '../events';
import '../token-item-base';
import { tokenItemBaseHostStyle } from '../token-item-base';
import '../token-item-loader';
let TokenItemCrossChainFlatElement = class TokenItemCrossChainFlatElement extends LitElement {
    constructor() {
        super(...arguments);
        this.showFavoriteTokenToggle = false;
        this.mobileView = false;
        this.index = 0;
        this.isFavorite = false;
        this.applicationContext = lazyAppContextConsumer(this);
        this.task = new Task(this, async ([tokenId]) => {
            if (!tokenId)
                throw new Error('');
            return await this.applicationContext.value.tokenStorage.getTokenById({
                tokenRecordId: tokenId,
            });
        }, () => [this.tokenId, this.walletAddress]);
    }
    static { this.tagName = 'inch-token-item-cross-chain-flat'; }
    static { this.styles = tokenItemBaseHostStyle; }
    render() {
        return this.task.render({
            complete: () => this.renderTokenViewOrLoader(),
            pending: () => this.renderTokenViewOrLoader(),
            error: () => this.renderTokenViewOrLoader(),
        });
    }
    renderTokenViewOrLoader() {
        return this.renderTokenView(this.task.value);
    }
    renderTokenView(token) {
        const chain = token ? getChainById(token.chainId) : null;
        let favoriteIconStyle = {
            border: 'var(--color-content-content-secondary)',
        };
        if (this.isFavorite) {
            favoriteIconStyle = {
                border: 'var(--color-core-orange-warning)',
                body: 'var(--color-core-orange-warning)',
            };
        }
        appendClass(this, {
            grid: true,
            'show-favorite-token-toggle': this.showFavoriteTokenToggle,
            'favorite-token': this.isFavorite,
            'mobile-view': this.mobileView,
        });
        return html ` <inch-token-item-base
      .tokenChainId="${token?.chainId}"
      .tokenAddress="${token?.address}"
      .tokenNameText="${token?.name}"
      .tokenNetworkText="${chain?.name ? `on ${chain?.name}` : undefined}"
      .symbol="${token?.symbol}"
      .walletAddress="${this.walletAddress}"
      .mobileView="${this.mobileView}"
      .showIconAfter="${this.showFavoriteTokenToggle}"
      .iconAfterName="${'startDefault16'}"
      .iconAfterProps="${favoriteIconStyle}"
      .showIconAfterOnHover="${!this.isFavorite}"
      @onClickIconAfter="${() => {
            if (!this.tokenId)
                return;
            this.isFavorite = !this.isFavorite;
            favoriteToken(this, [this.isFavorite, this.tokenId]);
        }}"
      @onClickToken="${() => {
            if (!token)
                return;
            selectToken(this, token);
        }}"
    ></inch-token-item-base>`;
    }
};
__decorate([
    property({ type: String, attribute: false }),
    __metadata("design:type", String)
], TokenItemCrossChainFlatElement.prototype, "tokenId", void 0);
__decorate([
    property({ type: String, attribute: false }),
    __metadata("design:type", String)
], TokenItemCrossChainFlatElement.prototype, "walletAddress", void 0);
__decorate([
    property({ type: Boolean, attribute: false }),
    __metadata("design:type", Object)
], TokenItemCrossChainFlatElement.prototype, "showFavoriteTokenToggle", void 0);
__decorate([
    property({ type: Boolean, attribute: false }),
    __metadata("design:type", Object)
], TokenItemCrossChainFlatElement.prototype, "mobileView", void 0);
__decorate([
    property({ type: Number, attribute: false }),
    __metadata("design:type", Object)
], TokenItemCrossChainFlatElement.prototype, "index", void 0);
__decorate([
    property({ type: Boolean, attribute: false }),
    __metadata("design:type", Object)
], TokenItemCrossChainFlatElement.prototype, "isFavorite", void 0);
TokenItemCrossChainFlatElement = __decorate([
    customElement(TokenItemCrossChainFlatElement.tagName)
], TokenItemCrossChainFlatElement);
export { TokenItemCrossChainFlatElement };
//# sourceMappingURL=token-item-cross-chain-flat.element.js.map